import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './Login.module.scss';
import { useSetRecoilState } from 'recoil';
import { TokenAtom } from '../../Recoil/TokenAtom';
import { FaUser, FaLock } from 'react-icons/fa';
import common from '../../common';
import { useLocation, useNavigate } from 'react-router-dom';



import { useDispatch } from 'react-redux';
import { setLoginInfo } from '../../store/userSlice';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



function setAccessTokenWithExpiry(token, expiryTimeInHours) {
    const now = new Date();
    const expiryTime = now.getTime() + expiryTimeInHours * 60 * 60 * 1000; // 현재 시간 + 만료 시간 (밀리초)
    const item = {
        token: token,
        expiry: expiryTime,
    };
    sessionStorage.setItem('accessToken', JSON.stringify(item));
}



function Login() {
    const { pChkbox, useAlert } = common();
    const { pAlert, AlertComponent } = useAlert(); // 훅 사용

    const location = useLocation();
    const navigate = useNavigate();
    const redirectedFrom = location.state?.redirectedFrom || '/'; // 기본값으로 루트 경로 지정

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberEmail, setRememberEmail] = useState(false);
    const setToken = useSetRecoilState(TokenAtom);
    const [isLoginSuccess, setLoginSuccess] = useState(false);

    useEffect(() => {
        const savedEmail = localStorage.getItem('savedEmail');
        if (savedEmail) {
            setEmail(savedEmail);
            setRememberEmail(true);
        }
    }, []);

    
    const dispatch = useDispatch();


    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_BASE_URL}/yehs_login/out/login`, { email, password }, {
                withCredentials: true
            });
            if (response.data.result === 't' && response.data.token) {
                setAccessTokenWithExpiry(response.data.token, 2); // 2시간 동안 유효하도록 설정
                setToken(response.data.token); // TokenAtom 업데이트
                setLoginSuccess(true); // 로그인 성공 상태 설정
                navigate(redirectedFrom);


                dispatch(setLoginInfo(response.data.idx)); // Redux에 로그인 정보 저장


                if (rememberEmail) {
                    localStorage.setItem('savedEmail', email);
                } else {
                    localStorage.removeItem('savedEmail');
                }
            } else {
                pAlert(response.data.msg);
            }
        } catch (error) {
            console.error('Login failed:', error);
            pAlert('로그인에 실패했습니다3. 다시 시도해주세요.');
        }
    };

    const handleRememberEmailChange = (e) => {
        const checked = e.target.checked;
        setRememberEmail(checked);
        if (checked) {
            localStorage.setItem('savedEmail', email);
        } else {
            localStorage.removeItem('savedEmail');
        }
    };

    useEffect(() => {
        if (rememberEmail) {
            localStorage.setItem('savedEmail', email);
        }
    }, [email, rememberEmail]);

    const joinButtonClick = () => {
        navigate('/join');
    };

    const idPwButtonClick = () => {
        navigate('/findIdPw');
    };

    return (
        <>
            <AlertComponent />
            <div className={`${styles.login_wrap} flex_center`}>
                <div className={styles.login_box}>
                    <div className={styles.login_inner_box}>
                        <div className={styles.lg_input_wrap}>
                            <div className={`${styles.lg_logo_box} flex_center`}>
                                <img src="/img/hdlogo.png" alt="logo" />
                            </div>
                            <form onSubmit={handleSubmit}>
                                <div className={(styles.lg_input_box)}>
                                    <FaUser className={styles.c_icon} />
                                    <input
                                        type="text"
                                        autoFocus
                                        placeholder='이메일'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className={(styles.lg_input_box)}>
                                    <FaLock className={styles.c_icon} />
                                    <input
                                        type="password"
                                        placeholder='비밀번호'
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <div className="login_wrap p_chkbox_box">
                                    <label className="login_wrap p_chkbox">
                                        <input
                                            type="checkbox"
                                            checked={rememberEmail}
                                            onChange={handleRememberEmailChange}
                                            onClick={(e) => pChkbox(e.target.parentElement)} />
                                        <span>이메일 저장하기</span>
                                    </label>
                                </div>
                                <div className={styles.lg_btn_box}>
                                    <button type="submit" className={styles.login_input_btn}><span className='f_bigger f_400 f_white'>로그인</span></button>
                                </div>
                            </form>
                            <div className={styles.cont_txt_box}>
                                <button className={`${styles.cont_txt} ${styles.idpw_cont_txt} `} onClick={idPwButtonClick}>ID / PW 찾기</button>
                                <span>|</span>
                                <button className={`${styles.cont_txt} ${styles.join_cont_txt} `} onClick={joinButtonClick}>회원가입</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;